

import React, { useState, useEffect } from 'react';
import './App.css';

// Simple icon components (since lucide-react might not be installed)
const Search = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8"></circle>
    <path d="m21 21-4.35-4.35"></path>
  </svg>
);

const ShoppingBag = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <path d="M16 10a4 4 0 0 1-8 0"></path>
  </svg>
);

const Heart = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </svg>
);

const X = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

function IkeaStore() {
  const [searchQuery, setSearchQuery] = useState('');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Default/Featured Products
  const defaultProducts = [
    {
      id: "default1",
      productId: "73978",
      name: "Joey Glass Bud Vase - Blue",
      description: "Beautiful glass vase",
      price: 7,
      currency: "AED",
      image: "https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/1/1/112AIC9904334_1.JPG",
      images: ["https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/1/1/112AIC9904334_1.JPG"],
      stockStatus: "IN_STOCK",
      sku: "112AIC9904334",
      categories: ["Accessories", "Home Decor"]
    },
    {
      id: "default2",
      productId: "73979",
      name: "Modern Ceramic Planter",
      description: "Contemporary ceramic planter",
      price: 25,
      currency: "AED",
      image: "https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/2/2/221HEL9900348_01_4.jpg",
      images: ["https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/2/2/221HEL9900348_01_4.jpg"],
      stockStatus: "IN_STOCK",
      sku: "PLANTER001",
      categories: ["Planters", "Decor"]
    },
    {
      id: "default3",
      productId: "73980",
      name: "Wooden Wall Shelf",
      description: "Rustic wooden shelf",
      price: 45,
      currency: "AED",
      image: "https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/0/1/013DGB2000004_4.JPG",
      images: ["https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/0/1/013DGB2000004_4.JPG"],
      stockStatus: "IN_STOCK",
      sku: "SHELF001",
      categories: ["Shelves", "Furniture"]
    },
    {
      id: "default4",
      productId: "73981",
      name: "Table Lamp - Gold",
      description: "Elegant table lamp",
      price: 89,
      currency: "AED",
      image: "https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/1/8/181AIC9902432_5.jpg",
      images: ["https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/1/8/181AIC9902432_5.jpg"],
      stockStatus: "IN_STOCK",
      sku: "LAMP001",
      categories: ["Lighting", "Decor"]
    },
    {
      id: "default5",
      productId: "73982",
      name: "Throw Pillow - Geometric",
      description: "Comfortable throw pillow",
      price: 35,
      currency: "AED",
      image: "https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/1/2/122LPM9900017_1.JPG",
      images: ["https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/1/2/122LPM9900017_1.JPG"],
      stockStatus: "IN_STOCK",
      sku: "PILLOW001",
      categories: ["Textiles", "Decor"]
    },
    {
      id: "default6",
      productId: "73983",
      name: "Wall Mirror - Round",
      description: "Round decorative mirror",
      price: 120,
      currency: "AED",
      image: "https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/1/9/192ATO9900631_4.jpg",
      images: ["https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/1/9/192ATO9900631_4.jpg"],
      stockStatus: "IN_STOCK",
      sku: "MIRROR001",
      categories: ["Mirrors", "Decor"]
    },
    {
      id: "default7",
      productId: "73984",
      name: "Coffee Table - Wood",
      description: "Stylish coffee table",
      price: 250,
      currency: "AED",
      image: "https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/0/4/041MYT0500015_1.JPG",
      images: ["https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/0/4/041MYT0500015_1.JPG"],
      stockStatus: "IN_STOCK",
      sku: "TABLE001",
      categories: ["Furniture", "Living Room"]
    },
    {
      id: "default8",
      productId: "73985",
      name: "Desk Organizer - Marble",
      description: "Elegant desk organizer",
      price: 55,
      currency: "AED",
      image: "https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/0/5/052FNX1000024_16.jpg",
      images: ["https://cdn.panhomestores.com/cdn-cgi/image/quality=70,height=,width=/media/catalog/product/0/5/052FNX1000024_16.jpg"],
      stockStatus: "IN_STOCK",
      sku: "ORG001",
      categories: ["Office", "Decor"]
    }
  ];

  // Simulated API call - replace with your actual API endpoint
  const searchProducts = async (query) => {
    if (!query.trim()) {
      setProducts([]);
      return;
    }

    setLoading(true);
    try {
      // Use environment variables for API configuration
      const url = process.env.REACT_APP_AZURE_SEARCH_URL;
      const apiKey = process.env.REACT_APP_AZURE_SEARCH_KEY;
      
      if (!url || !apiKey) {
        console.error('Missing API configuration. Please check your .env file.');
        setLoading(false);
        return;
      }
      
      var payload={"search":query,"count":true,"vectorQueries":[{"kind":"text","text":query,"fields":"chunk_vector"}],"queryType":"semantic","semanticConfiguration":"semantic-config","captions":"extractive","answers":"extractive|count-3","queryLanguage":"en-us","queryRewrites":"generative"}
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'api-key': apiKey
        },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      
      // Parse the products from the API response
      const parsedProducts = data.value.map(item => {
        const contentJson = JSON.parse(item.content_json);
        return {
          score: item['@search.rerankerScore'],
          id: item.id,
          productId: item.product_id,
          name: contentJson.name,
          description: contentJson.description?.html || '',
          price: contentJson.price_range.minimum_price.final_price.value,
          currency: contentJson.price_range.minimum_price.final_price.currency,
          image: item.image || contentJson.media_gallery[0]?.url,
          images: contentJson.media_gallery?.map(img => img.url) || [],
          stockStatus: contentJson.stock_status,
          sku: contentJson.sku,
          categories: contentJson.categories?.map(cat => cat.name) || [],
        };
      });

      const finaldata=parsedProducts.filter(item=>item.score>=2.0);

      console.log('Final data:', finaldata);
      
      
      setProducts(finaldata);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    if (searchQuery.trim()) {
      // Show skeleton loading immediately on typing
      setLoading(true);
      setProducts([]);

      // Debounce search for 500ms after user stops typing
      const delaySearch = setTimeout(() => {
        searchProducts(searchQuery);
      }, 500);

      return () => clearTimeout(delaySearch);
    } else {
      // Clear everything when search is empty
      setLoading(false);
      setProducts([]);
    }
  }, [searchQuery]);

  return (
    <div className="ikea-store">
      {/* Header */}
      <header className="ikea-header">
        <div className="header-container">
          <div className="header-content">
            <div className="header-left">
              <h1 className="logo">PAN HOMES</h1>
              {/* <nav className="main-nav">
                <a href="#products">Products</a>
                <a href="#rooms">Rooms</a>
                <a href="#offers">Offers</a>
                <a href="#ideas">Ideas</a>
              </nav> */}
            </div>
            <div className="header-right">
              <button className="icon-btn">
                <Heart />
              </button>
              <button className="icon-btn">
                <ShoppingBag />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Search Section */}
      <div className="hero-section">
        <div className="hero-container">
          <h2 className="hero-title">Find your perfect piece</h2>
          <p className="hero-subtitle">Search thousands of quality home furnishings</p>
          
          {/* Search Bar */}
          <div className="search-wrapper">
            <div className="search-container">
              <div className="search-icon">
                <Search />
              </div>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search for furniture, decor, and more..."
                className="search-input"
              />
              {loading && (
                <div className="search-loading">
                  <div className="spinner"></div>
                </div>
              )}
              
              {/* Products Dropdown */}
              {searchQuery && (
                <div className="products-dropdown">
                  {loading ? (
                    <div className="dropdown-products">
                      {[...Array(5)].map((_, index) => (
                        <div key={index} className="skeleton-item">
                          <div className="skeleton-image"></div>
                          <div className="skeleton-details">
                            <div className="skeleton-name"></div>
                            <div className="skeleton-category"></div>
                            <div className="skeleton-price"></div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : products.length > 0 ? (
                    <div className="dropdown-products">
                      {/* <div className="dropdown-results-header">
                        <span className="results-count">{products.length} results</span>
                      </div> */}
                      <div className="dropdown-products">
                        {products.map((product, index) => (
                          <div
                            key={`${product.id}-${index}`}
                            className="dropdown-product-item"
                            onClick={() => setSelectedProduct(product)}
                          >
                            <div className="dropdown-product-image">
                              <img
                                src={product.image}
                                alt={product.name}
                                onError={(e) => {
                                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="80" height="80"%3E%3Crect fill="%23f0f0f0" width="80" height="80"/%3E%3C/svg%3E';
                                }}
                              />
                            </div>
                            <div className="dropdown-product-details">
                              <h4 className="dropdown-product-name">{product.name}</h4>
                              {product.categories && product.categories.length > 0 && (
                                <p className="dropdown-product-category">{product.categories[0]}</p>
                              )}
                              <span className="dropdown-product-price">{product.currency} {product.price}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="dropdown-no-results">
                      <div className="no-results-icon">🔍</div>
                      <p className="no-results-text">No products found</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="main-content">
        <div className="main-container">
          <div>
            <div className="featured-header">
              <h3 className="featured-title">Featured Products</h3>
              <p className="featured-subtitle">Discover our curated collection</p>
            </div>
            <div className="products-grid">
              {defaultProducts.map((product, index) => (
                <div
                  key={product.id}
                  className="product-card"
                  onClick={() => setSelectedProduct(product)}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="product-image-container">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="product-image"
                      onError={(e) => {
                        e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect fill="%23f0f0f0" width="400" height="400"/%3E%3C/svg%3E';
                      }}
                    />
                    <button className="wishlist-btn">
                      <Heart />
                    </button>
                    {product.stockStatus === 'IN_STOCK' && (
                      <div className="stock-badge">In Stock</div>
                    )}
                  </div>
                  
                  <div className="product-info">
                    <h4 className="product-name">{product.name}</h4>
                    
                    {product.categories && product.categories.length > 0 && (
                      <p className="product-category">{product.categories[0]}</p>
                    )}
                    
                    <div className="product-footer">
                      <div className="product-price">
                        <span className="price-amount">{product.currency} {product.price}</span>
                      </div>
                      <button className="add-to-bag-btn">Add to bag</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      {/* Product Modal */}
      {selectedProduct && (
        <div className="modal-overlay" onClick={() => setSelectedProduct(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Product Details</h3>
              <button onClick={() => setSelectedProduct(null)} className="modal-close">
                <X />
              </button>
            </div>
            
            <div className="modal-body">
              <div className="modal-grid">
                {/* Images */}
                <div className="modal-images">
                  <div className="main-image">
                    <img src={selectedProduct.image} alt={selectedProduct.name} />
                  </div>
                  <div className="image-thumbnails">
                    {selectedProduct.images.slice(0, 4).map((img, idx) => (
                      <div key={idx} className="thumbnail">
                        <img src={img} alt="" />
                      </div>  
                    ))}
                  </div>
                </div>
                
                {/* Details */}
                <div className="modal-details">
                  <h2 className="detail-name">{selectedProduct.name}</h2>
                  
                  <div className="detail-price">
                    <span className="detail-price-amount">
                      {selectedProduct.currency} {selectedProduct.price}
                    </span>
                  </div>
                  
                  {selectedProduct.stockStatus === 'IN_STOCK' && (
                    <div className="detail-stock">
                      <div className="stock-indicator"></div>
                      <span>In Stock</span>
                    </div>
                  )}
                  
                  <div className="detail-meta">
                    <p className="detail-sku">SKU: {selectedProduct.sku}</p>
                    {selectedProduct.categories && selectedProduct.categories.length > 0 && (
                      <div className="detail-categories">
                        {selectedProduct.categories.slice(0, 5).map((cat, idx) => (
                          <span key={idx} className="category-tag">{cat}</span>
                        ))}
                      </div>
                    )}
                  </div>
                  
                  {selectedProduct.description && (
                    <div className="detail-description">
                      <h4>Description</h4>
                      <div dangerouslySetInnerHTML={{ __html: selectedProduct.description }} />
                    </div>
                  )}
                  
                  <div className="detail-actions">
                    <button className="btn-primary">Add to Shopping Bag</button>
                    <button className="btn-secondary">
                      <Heart />
                      <span>Add to Wishlist</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default IkeaStore;